/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bring_Your_Own_Stripe_ByosInputs */

const en_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring Your Own Stripe (BYOS)`)
};

const es_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trae tu propio Stripe (BYOS)`)
};

const fr_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apportez votre propre Stripe (BYOS)`)
};

const de_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring Your Own Stripe (BYOS)`)
};

const ja_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYOS (ご自身のStripeを利用)`)
};

const zh_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自带 Stripe (BYOS)`)
};

const ar_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدم حساب Stripe الخاص بك (BYOS)`)
};

const id_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawa Stripe Sendiri (BYOS)`)
};

const it_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa il Tuo Stripe (BYOS)`)
};

const ru_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключите свой Stripe (BYOS)`)
};

const pt_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traga seu próprio Stripe (BYOS)`)
};

const ko_bring_your_own_stripe_byos = /** @type {(inputs: Bring_Your_Own_Stripe_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자체 Stripe 연결 (BYOS)`)
};

/**
* | output |
* | --- |
* | "Bring Your Own Stripe (BYOS)" |
*
* @param {Bring_Your_Own_Stripe_ByosInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bring_your_own_stripe_byos = /** @type {((inputs?: Bring_Your_Own_Stripe_ByosInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bring_Your_Own_Stripe_ByosInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bring_your_own_stripe_byos(inputs)
	if (locale === "es") return es_bring_your_own_stripe_byos(inputs)
	if (locale === "fr") return fr_bring_your_own_stripe_byos(inputs)
	if (locale === "de") return de_bring_your_own_stripe_byos(inputs)
	if (locale === "ja") return ja_bring_your_own_stripe_byos(inputs)
	if (locale === "zh") return zh_bring_your_own_stripe_byos(inputs)
	if (locale === "ar") return ar_bring_your_own_stripe_byos(inputs)
	if (locale === "id") return id_bring_your_own_stripe_byos(inputs)
	if (locale === "it") return it_bring_your_own_stripe_byos(inputs)
	if (locale === "ru") return ru_bring_your_own_stripe_byos(inputs)
	if (locale === "pt") return pt_bring_your_own_stripe_byos(inputs)
	return ko_bring_your_own_stripe_byos(inputs)
});